import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import MeInstoreOnlyOfferDetails from './components/MeInstoreOnlyOfferDetails';

import './MeInstoreOnlyOffer.scss';

function MeInstoreOnlyOffer({ offer }) {
  return (
    <div className="mn_meInstoreOnlyOffer">
      <ContentWrap>
        <MeInstoreOnlyOfferDetails offer={offer} />
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><MeInstoreOnlyOffer {...props} /></ComponentErrorBoundary>;
